import React, { useEffect, useMemo, useRef, useState } from "react";

import Slider from "react-slick";

import managementBanner from "../assets/img/schoolbanner/school-of-management.webp";
import commerceBanner from  "../assets/img/schoolbanner/school-of-commerce.webp";
import engineeringBanner from  "../assets/img/schoolbanner/school-of-engineering-and-technology.webp";
import informationTechnologyBanner from  "../assets/img/schoolbanner/school-of-information-and-technology.webp";
import scienceBanner from  "../assets/img/schoolbanner/school-of-library-and-information-science.webp";
import artsBanner from  "../assets/img/schoolbanner/school-of-arts-and-humanities.webp";
import lawBanner from  "../assets/img/schoolbanner/school-of-law.webp";
import pharmacyBanner from  "../assets/img/schoolbanner/school-of-pharmacy.webp";
import designBanner from  "../assets/img/schoolbanner/school-of-design.webp";
import educationBanner from  "../assets/img/schoolbanner/school-of-education.webp";
import journalismBanner from  "../assets/img/schoolbanner/school-of-journalism-and-mass-communication.webp";
import hotelManagementBanner from  "../assets/img/schoolbanner/school-of-hotel-management.webp";
import mediaBanner from  "../assets/img/schoolbanner/school-of-media-and-entertainment.webp";
import libraryBanner from  "../assets/img/schoolbanner/school-of-library-and-information-science.webp";
import yogaBanner from  "../assets/img/schoolbanner/school-of-yoga-and-naturopathy.webp";
import lifeScienceBanner from  "../assets/img/schoolbanner/school-of-library-and-information-science.webp";
import vocationalBanner from  "../assets/img/schoolbanner/school-of-vocational-management.webp";
import healthScienceBanner from  "../assets/img/schoolbanner/school-of-health-and-allied-science.webp";

const allSchools = [
    {
        number: "01",
        slug: "management",
        name: "School of Management",
        category: "Business & Leadership",
        description:
            "Developing responsible leaders through management education, entrepreneurship and industry-oriented learning.",
        link: "/school-of-management",
        image: managementBanner,
    },
    {
        number: "02",
        slug: "commerce",
        name: "School of Commerce",
        category: "Finance & Commerce",
        description:
            "Building expertise in accounting, finance, taxation, banking and contemporary business practices.",
        link: "/school-of-commerce",
        image: commerceBanner,
    },
    {
        number: "03",
        slug: "engineering-technology",
        name: "School of Engineering & Technology",
        category: "Engineering & Innovation",
        description:
            "Advancing technical knowledge through applied engineering, research, design and practical problem solving.",
        link: "/school-of-engineering-technology",
        image: engineeringBanner,
    },
    {
        number: "04",
        slug: "information-technology",
        name: "School of Information & Technology",
        category: "Computing & Digital Innovation",
        description:
            "Preparing future-ready professionals across computing, software, data, artificial intelligence and digital technologies.",
        link: "/school-of-information-technology",
        image: informationTechnologyBanner,
    },
    {
        number: "05",
        slug: "science",
        name: "School of Science",
        category: "Scientific Discovery",
        description:
            "Encouraging scientific enquiry, laboratory learning and research across fundamental and applied sciences.",
        link: "/school-of-science",
        image: scienceBanner,
    },
    {
        number: "06",
        slug: "arts-humanities",
        name: "School of Arts & Humanities",
        category: "Society & Culture",
        description:
            "Exploring language, society, culture and human experience through interdisciplinary education.",
        link: "/school-of-arts-humanities",
        image: artsBanner,
    },
    {
        number: "07",
        slug: "law",
        name: "School of Law",
        category: "Law & Justice",
        description:
            "Preparing legal professionals through academic rigour, advocacy, ethics and practical legal exposure.",
        link: "/school-of-law",
        image: lawBanner,
    },
    {
        number: "08",
        slug: "pharmacy",
        name: "School of Pharmacy",
        category: "Pharmaceutical Sciences",
        description:
            "Combining pharmaceutical knowledge, laboratory practice, healthcare awareness and research-based learning.",
        link: "/school-of-pharmacy",
        image: pharmacyBanner,
    },
    {
        number: "09",
        slug: "design",
        name: "School of Design",
        category: "Design & Creativity",
        description:
            "Transforming creative thinking into functional, responsible and human-centred design solutions.",
        link: "/school-of-design",
        image: designBanner,
    },
    {
        number: "10",
        slug: "education",
        name: "School of Education",
        category: "Teaching & Learning",
        description:
            "Developing reflective educators through pedagogy, classroom practice and learner-centred approaches.",
        link: "/school-of-education",
        image: educationBanner,
    },
    {
        number: "11",
        slug: "journalism-mass-communication",
        name: "School of Journalism & Mass Communication",
        category: "Media & Communication",
        description:
            "Preparing storytellers and communication professionals for journalism, digital media and public engagement.",
        link: "/school-of-journalism-mass-communication",
        image: journalismBanner,
    },
    {
        number: "12",
        slug: "hotel-management",
        name: "School of Hotel Management",
        category: "Hospitality & Tourism",
        description:
            "Creating hospitality professionals through service excellence, culinary learning and industry exposure.",
        link: "/school-of-hotel-management",
        image: hotelManagementBanner,
    },
    {
        number: "13",
        slug: "media-entertainment",
        name: "School of Media & Entertainment",
        category: "Creative Media",
        description:
            "Integrating creativity, technology and production skills for careers across modern entertainment industries.",
        link: "/school-of-media-entertainment",
        image: mediaBanner,
    },
    {
        number: "14",
        slug: "library-information-science",
        name: "School of Library & Information Science",
        category: "Knowledge Management",
        description:
            "Advancing information organisation, digital libraries, documentation and responsible knowledge access.",
        link: "/school-of-library-information-science",
        image: libraryBanner,
    },
    {
        number: "15",
        slug: "yoga-naturopathy",
        name: "School of Yoga & Naturopathy",
        category: "Wellness & Holistic Health",
        description:
            "Promoting holistic wellbeing through yoga, natural health practices and evidence-informed learning.",
        link: "/school-of-yoga-naturopathy",
        image: yogaBanner,
    },
    {
        number: "16",
        slug: "life-science",
        name: "School of Life Science",
        category: "Life & Biological Sciences",
        description:
            "Exploring living systems through laboratory study, biological research and interdisciplinary science.",
        link: "/school-of-life-science",
        image: lifeScienceBanner,
    },
    {
        number: "17",
        slug: "vocational-studies",
        name: "School of Vocational Studies",
        category: "Skills & Employability",
        description:
            "Delivering practical, career-oriented education designed around workplace skills and professional readiness.",
        link: "/school-of-vocational-studies",
        image: vocationalBanner,
    },
    {
        number: "18",
        slug: "health-allied-science",
        name: "School of Health & Allied Science",
        category: "Healthcare Education",
        description:
            "Preparing healthcare professionals through scientific learning, practical training and patient-focused values.",
        link: "/school-of-health-allied-science",
        image: healthScienceBanner,
    },
];

function SchoolSliderArrow({ direction, onClick }) {
    const isPrevious = direction === "previous";

    return (
        <button
            type="button"
            onClick={onClick}
            aria-label={isPrevious ? "Previous schools" : "Next schools"}
            className={`!absolute !top-[-82px] !z-20 !flex !h-12 !w-12 !items-center !justify-center !rounded-full !border !border-[#8B1E3F]/20 !bg-white !text-[#071A2F] !shadow-lg !transition !duration-300 hover:!border-[#8B1E3F] hover:!bg-[#8B1E3F] hover:!text-white ${isPrevious ? "!left-auto !right-[60px]" : "!right-0"
                }`}
        >
            <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                className={`h-4 w-4 ${isPrevious ? "rotate-180" : ""}`}
                aria-hidden="true"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M5 12h14m-5-5 5 5-5 5"
                />
            </svg>
        </button>
    );
}



function OtherSchoolsSection({ excludeSchool }) {
    const visibleSchools = allSchools.filter(
        (school) => school.slug !== excludeSchool
    );

    const settings = {
        dots: false,
        arrows: true,
        infinite: visibleSchools.length > 3,
        speed: 650,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4200,
        pauseOnHover: true,
        swipeToSlide: true,
        nextArrow: <SchoolSliderArrow direction="next" />,
        prevArrow: <SchoolSliderArrow direction="previous" />,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    arrows: false,
                },
            },
        ],
    };

    return (
        <section
            className="relative overflow-hidden bg-[#8B1E3F]/[0.06] py-20 sm:py-24 lg:py-32"
            aria-labelledby="other-schools-heading"
        >
            <div className="pointer-events-none absolute inset-0">
                <div className="absolute -left-40 top-10 h-[420px] w-[420px] rounded-full bg-[#8B1E3F]/10 blur-[100px]" />
                <div className="absolute -bottom-40 right-0 h-[460px] w-[460px] rounded-full bg-[#D5AD57]/15 blur-[100px]" />

                <div
                    className="absolute inset-0 opacity-[0.025]"
                    style={{
                        backgroundImage:
                            "radial-gradient(#071A2F 1px, transparent 1px)",
                        backgroundSize: "28px 28px",
                    }}
                />
            </div>

            <div className="relative mx-auto max-w-[1320px] px-5 sm:px-8 lg:px-10">
                <div className="grid gap-8 pr-0 sm:pr-32 lg:grid-cols-[1fr_0.55fr] lg:items-end">
                    <div>
                        <div className="flex items-center gap-4">
                            <span className="h-px w-10 bg-[#8B1E3F]" />
                            <span className="text-xs font-bold uppercase tracking-[0.22em] text-[#8B1E3F]">
                                Explore ISBM University
                            </span>
                        </div>

                        <h2
                            id="other-schools-heading"
                            className="mt-6 max-w-4xl text-[clamp(42px,5vw,72px)] font-normal leading-[1.03] tracking-[-0.045em] text-[#071A2F]"
                            style={{
                                fontFamily: '"Libre Caslon Display", Georgia, serif',
                            }}
                        >
                            Discover knowledge
                            <span className="italic text-[#8B1E3F]">
                                {" "}
                                across disciplines.
                            </span>
                        </h2>
                    </div>

                    <p className="max-w-xl text-base leading-8 text-[#132337]/65 lg:pb-2">
                        Explore a multidisciplinary academic community where every school
                        contributes a distinct perspective to learning, research and
                        professional development.
                    </p>
                </div>

                <div className="relative mt-16">
                    <div
                        className="
    relative mt-16
    [&_.slick-list]:overflow-hidden
    [&_.slick-track]:flex
    [&_.slick-slide]:h-auto
    [&_.slick-slide>div]:h-full
  "
                    >
                        <Slider {...settings}>
                            {visibleSchools.map((school) => (
                                <div key={school.slug} className="h-full px-2.5 pb-10">
                                    <article className="group relative flex h-full min-h-[500px] flex-col overflow-hidden rounded-[28px] border border-[#8B1E3F]/10 bg-white shadow-[0_18px_50px_rgba(7,26,47,0.07)] transition duration-500 hover:-translate-y-2 hover:border-[#D5AD57] hover:shadow-[0_28px_70px_rgba(7,26,47,0.13)]">
                                        {/* School image */}
                                        <div className="relative h-[205px] shrink-0 overflow-hidden bg-[#071A2F]">
                                            <img
                                                src={school.image}
                                                alt={`${school.name} at ISBM University`}
                                                loading="lazy"
                                                className="h-full w-full object-cover transition duration-700 group-hover:scale-105"
                                            />

                                            <div className="absolute inset-0 bg-gradient-to-t from-[#071A2F]/80 via-[#071A2F]/10 to-transparent" />

                                            <span className="absolute left-5 top-5 rounded-full border border-white/20 bg-[#071A2F]/70 px-3.5 py-2 text-[10px] font-bold uppercase tracking-[0.16em] text-[#D5AD57] backdrop-blur-md">
                                                {school.category}
                                            </span>

                                            <span
                                                className="absolute bottom-4 right-5 text-5xl font-normal leading-none text-white/30"
                                                style={{
                                                    fontFamily: '"Libre Caslon Display", Georgia, serif',
                                                }}
                                            >
                                                {school.number}
                                            </span>
                                        </div>

                                        {/* School content */}
                                        <div className="relative flex flex-1 flex-col p-6 sm:p-7">
                                            <div className="flex items-start justify-between gap-4">
                                                <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#8B1E3F]">
                                                    ISBM University
                                                </span>

                                                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-[#071A2F]/10 text-[#071A2F] transition duration-300 group-hover:border-[#8B1E3F] group-hover:bg-[#8B1E3F] group-hover:text-white">
                                                    <svg
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        strokeWidth="1.8"
                                                        className="h-4 w-4 transition duration-300 group-hover:-rotate-45"
                                                        aria-hidden="true"
                                                    >
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            d="M5 12h14m-5-5 5 5-5 5"
                                                        />
                                                    </svg>
                                                </span>
                                            </div>

                                            <h3
                                                className="mt-4 text-[27px] font-normal leading-[1.18] text-[#071A2F]"
                                                style={{
                                                    fontFamily: '"Libre Caslon Display", Georgia, serif',
                                                }}
                                            >
                                                {school.name}
                                            </h3>

                                            <p className="mt-4 text-sm leading-7 text-[#132337]/60">
                                                {school.description}
                                            </p>

                                            <div className="mt-auto border-t border-[#071A2F]/10 pt-5">
                                                <span className="inline-flex items-center gap-3 text-xs font-bold uppercase tracking-[0.14em] text-[#071A2F] transition group-hover:text-[#8B1E3F]">
                                                    Explore school
                                                    <span className="h-px w-8 bg-[#D5AD57] transition-all duration-300 group-hover:w-12" />
                                                </span>
                                            </div>
                                        </div>

                                        <div className="absolute bottom-0 left-0 z-10 h-[3px] w-0 bg-gradient-to-r from-[#8B1E3F] to-[#D5AD57] transition-all duration-500 group-hover:w-full" />

                                        <a
                                            href={school.link}
                                            className="absolute inset-0 z-20"
                                            aria-label={`Explore ${school.name}`}
                                        />
                                    </article>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>

                <div className="mt-3 flex flex-col gap-6 rounded-[24px] border border-[#8B1E3F]/10 bg-white/65 p-6 backdrop-blur-md sm:flex-row sm:items-center sm:justify-between sm:p-8">
                    <div>
                        <span className="text-xs font-bold uppercase tracking-[0.18em] text-[#8B1E3F]">
                            One university · Multiple possibilities
                        </span>

                        <p
                            className="mt-2 text-2xl font-normal text-[#071A2F]"
                            style={{
                                fontFamily: '"Libre Caslon Display", Georgia, serif',
                            }}
                        >
                            Find the academic path that reflects your ambition.
                        </p>
                    </div>

                    <a
                        href="/schools"
                        className="inline-flex shrink-0 items-center justify-center gap-3 rounded-full bg-[#8B1E3F] px-7 py-4 text-sm font-bold text-white transition duration-300 hover:-translate-y-1 hover:bg-[#071A2F]"
                    >
                        View all schools
                        <span aria-hidden="true">→</span>
                    </a>
                </div>
            </div>
        </section>
    );
}

export default OtherSchoolsSection;
